import { useState, useEffect } from 'react';
import { container } from '@/di';
import { TYPES } from '@/di/tokens';
import { ListAdicionalesAction } from '@/application/actions';
import { Adicional } from '@/domain/entities/Adicional';

export const useAdicionales = (search?: string, activo?: boolean) => {
  const [adicionales, setAdicionales] = useState<Adicional[]>([]);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<Error | null>(null);

  const loadAdicionales = async () => {
    setIsLoading(true);
    setError(null);
    try {
      const action = container.get<ListAdicionalesAction>(
        TYPES.ListAdicionalesAction
      );
      const result = await action.execute(search, activo);
      setAdicionales(result);
    } catch (err) {
      setError(
        err instanceof Error ? err : new Error('Error al cargar adicionales')
      );
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    loadAdicionales();
  }, [search, activo]);

  return { adicionales, isLoading, error, refetch: loadAdicionales };
};
